// Bausteine der Vereinsverwaltung: Symbole, Siegel, Status, Dialoge.
// Gestaltung in styles/vereine.css (Vorsilbe vv-).
import React, { useEffect, useRef, useState } from 'react';
import { statusVon, initialen, istVerein } from './vereinHilfen';

const PFADE = {
  suche: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  x: <path d="M18 6 6 18M6 6l12 12" />,
  rechts: <path d="m9 18 6-6-6-6" />,
  links: <path d="m15 18-6-6 6-6" />,
  person: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  leute: <><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0" /><path d="M16 4.5a3.5 3.5 0 0 1 0 7M18 14a6 6 0 0 1 3.5 6" /></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>,
  tel: <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2" />,
  ort: <><path d="M12 21s-7-6.5-7-12a7 7 0 0 1 14 0c0 5.5-7 12-7 12z" /><circle cx="12" cy="9" r="2.5" /></>,
  welt: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></>,
  schloss: <><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>,
  offen: <><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 7.5-2" /></>,
  archiv: <><rect x="3" y="4" width="18" height="5" rx="1" /><path d="M5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9M10 13h4" /></>,
  muell: <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" />,
  stift: <><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="m13 7 4 4" /></>,
  pokal: <><path d="M8 4h8v5a4 4 0 0 1-8 0z" /><path d="M8 6H5a3 3 0 0 0 3 4M16 6h3a3 3 0 0 1-3 4M12 13v4M8 20h8" /></>,
  kal: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  achtung: <><path d="M12 3 2 20h20z" /><path d="M12 10v4M12 17h.01" /></>,
  haken: <path d="m5 12 5 5 9-10" />,
  neu: <><path d="M4 4v6h6M20 20v-6h-6" /><path d="M5 15a8 8 0 0 0 14 2M19 9A8 8 0 0 0 5 7" /></>,
  mehr: <><circle cx="5" cy="12" r="1.3" /><circle cx="12" cy="12" r="1.3" /><circle cx="19" cy="12" r="1.3" /></>,
  filter: <path d="M3 5h18M6 12h12M10 19h4" />,
  export: <path d="M12 3v12M7 8l5-5 5 5M5 15v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" />,
  wolke: <><path d="M7 18a5 5 0 0 1-.5-10A6 6 0 0 1 18 9a4.5 4.5 0 0 1-.5 9z" /><path d="m4 4 16 16" /></>,
  verbind: <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />,
  zusammen: <><path d="M6 4v5a3 3 0 0 0 3 3h6a3 3 0 0 1 3 3v5M18 4v5a3 3 0 0 1-3 3" /><path d="m15 17 3 3 3-3" /></>,
  kopie: <><rect x="8" y="8" width="12" height="12" rx="2" /><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3" /></>,
};

export function Sym({ n, className = '' }) {
  return (
    <svg className={`vv-svg ${className}`} viewBox="0 0 24 24" aria-hidden="true">{PFADE[n]}</svg>
  );
}

export function Siegel({ verein, gross = false }) {
  return (
    <span className={`vv-siegel${istVerein(verein) ? '' : ' vv-grau'}${gross ? ' vv-gross' : ''}`} aria-hidden="true">
      {initialen(verein?.name)}
    </span>
  );
}

export function StatusAbzeichen({ verein, klein = false }) {
  const [k, t] = statusVon(verein);
  return <span className={`vv-st vv-st-${k}${klein ? ' vv-st-klein' : ''}`}>{t}</span>;
}

export function Fehlt({ children }) {
  return <span className="vv-fehlt">{children}</span>;
}

/** Leerer Zustand, Fehler, keine Treffer. */
export function LeerKarte({ sym, titel, text, fehler = false, technisch, children }) {
  return (
    <div className={`vv-leer${fehler ? ' vv-leer-fehler' : ''}`} role={fehler ? 'alert' : undefined}>
      <div className="vv-ring"><Sym n={sym} /></div>
      <h3>{titel}</h3>
      {text && <p>{text}</p>}
      {technisch && <p><code>{technisch}</code></p>}
      {children && <div className="vv-leer-knoepfe">{children}</div>}
    </div>
  );
}

/* ═════════════ Dialoge ═════════════ */

/** Rahmen aller Rückfragen. Auch von Verwaltung › Divisionen benutzt (breit = 640 px). */
export function Dialog({ sym, rot, titel, text, children, fuss, onSchliessen, belegt, breit = false }) {
  const rahmen = useRef(null);
  useEffect(() => {
    const taste = (e) => { if (e.key === 'Escape' && !belegt) onSchliessen(); };
    document.addEventListener('keydown', taste);
    const erstes = rahmen.current?.querySelector('input, button.vv-k-haupt');
    erstes?.focus();
    return () => document.removeEventListener('keydown', taste);
  }, [onSchliessen, belegt]);
  return (
    <div className="vv-hinter" onMouseDown={(e) => { if (e.target === e.currentTarget && !belegt) onSchliessen(); }}>
      <div className={`vv-dialog${breit ? ' dv-breit' : ''}`} role="dialog" aria-modal="true" aria-labelledby="vv-dialog-titel" ref={rahmen}>
        <div className="vv-dialog-kopf">
          <div className={`vv-ring${rot ? ' vv-rot' : ''}`}><Sym n={sym} /></div>
          <div><h2 id="vv-dialog-titel">{titel}</h2>{text && <p>{text}</p>}</div>
        </div>
        <div className="vv-dialog-inhalt">{children}</div>
        <div className="vv-dialog-fuss">{fuss}</div>
      </div>
    </div>
  );
}

export function useAktion(onOk) {
  const [belegt, setBelegt] = useState(false);
  const [fehler, setFehler] = useState('');
  const los = async (...args) => {
    setBelegt(true); setFehler('');
    try { await onOk(...args); } catch (e) { setFehler(e.message || 'Das hat nicht geklappt'); setBelegt(false); }
  };
  return { belegt, fehler, los };
}

export const FehlerZeile = ({ text }) => (text ? <div className="vv-hinweis vv-hinweis-rot" role="alert"><Sym n="achtung" /><div>{text}</div></div> : null);

export function SperrenDialog({ verein, onOk, onSchliessen }) {
  const [grund, setGrund] = useState('');
  const { belegt, fehler, los } = useAktion(onOk);
  return (
    <Dialog sym="schloss" rot titel={`${verein.name} sperren?`} text="Das Konto kann sich danach nicht mehr anmelden." onSchliessen={onSchliessen} belegt={belegt}
      fuss={<>
        <button className="vv-k" onClick={onSchliessen} disabled={belegt}>Abbrechen</button>
        <button className="vv-k vv-k-haupt" onClick={() => los(grund.trim())} disabled={belegt}><Sym n="schloss" /> {belegt ? 'Sperrt …' : 'Sperren'}</button>
      </>}>
      <ul>
        <li>Wer schon angemeldet ist, fliegt bei der nächsten Aktion hinaus.</li>
        <li>Gemeldete Starter bleiben in den Turnieren.</li>
        <li>Freigeben geht jederzeit wieder.</li>
      </ul>
      <div className="vv-feld">
        <label htmlFor="vv-grund">Grund (sieht nur die Verwaltung)</label>
        <input id="vv-grund" maxLength={255} placeholder="z. B. Startgeld offen, Doppelkonto" value={grund} onChange={(e) => setGrund(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !belegt) los(grund.trim()); }} />
      </div>
      <FehlerZeile text={fehler} />
    </Dialog>
  );
}

export function FreigebenDialog({ verein, onOk, onSchliessen }) {
  const { belegt, fehler, los } = useAktion(onOk);
  return (
    <Dialog sym="offen" titel={`${verein.name} freigeben?`} text="Der Verein kann sich danach wieder anmelden und Starter melden." onSchliessen={onSchliessen} belegt={belegt}
      fuss={<>
        <button className="vv-k" onClick={onSchliessen} disabled={belegt}>Abbrechen</button>
        <button className="vv-k vv-k-haupt" onClick={() => los()} disabled={belegt}><Sym n="offen" /> {belegt ? 'Gibt frei …' : 'Freigeben'}</button>
      </>}>
      {verein.gesperrt_grund && <p className="vv-dialog-notiz">Gesperrt wegen: {verein.gesperrt_grund}</p>}
      <FehlerZeile text={fehler} />
    </Dialog>
  );
}

export function ArchivDialog({ verein, wettkaempfer, meldungen, onOk, onSchliessen }) {
  const [grund, setGrund] = useState('');
  const { belegt, fehler, los } = useAktion(onOk);
  return (
    <Dialog sym="archiv" titel={`${verein.name} archivieren?`} text="Der Verein verschwindet aus dem Bestand und steht danach im Archiv." onSchliessen={onSchliessen} belegt={belegt}
      fuss={<>
        <button className="vv-k" onClick={onSchliessen} disabled={belegt}>Abbrechen</button>
        <button className="vv-k vv-k-haupt" onClick={() => los(grund.trim())} disabled={belegt}><Sym n="archiv" /> {belegt ? 'Archiviert …' : 'Archivieren'}</button>
      </>}>
      <ul>
        <li>Meldungen und Ergebnisse bleiben erhalten{meldungen > 0 ? <> (<b>{meldungen}</b> Meldungen)</> : ''}, auch in Startlisten, Ranglisten und Urkunden.</li>
        <li><b>{wettkaempfer}</b> Wettkämpfer werden ausgeblendet: nicht mehr auswählbar, nicht mehr gezählt.</li>
        <li>Anmelden geht nicht mehr.</li>
        <li>Zurückholen blendet alles wieder ein, das Passwort bleibt.</li>
      </ul>
      <div className="vv-feld">
        <label htmlFor="vv-grund">Grund (freiwillig)</label>
        <input id="vv-grund" maxLength={500} placeholder="z. B. Verein aufgelöst, seit 2024 inaktiv" value={grund} onChange={(e) => setGrund(e.target.value)} />
      </div>
      <FehlerZeile text={fehler} />
    </Dialog>
  );
}

export function ZurueckholenDialog({ eintrag, onOk, onSchliessen }) {
  const { belegt, fehler, los } = useAktion(onOk);
  return (
    <Dialog sym="neu" titel={`${eintrag.name} zurückholen?`} text="Der Verein steht danach wieder im Bestand." onSchliessen={onSchliessen} belegt={belegt}
      fuss={<>
        <button className="vv-k" onClick={onSchliessen} disabled={belegt}>Abbrechen</button>
        <button className="vv-k vv-k-haupt" onClick={() => los()} disabled={belegt}><Sym n="neu" /> {belegt ? 'Holt zurück …' : 'Zurückholen'}</button>
      </>}>
      {eintrag.ausgeblendet ? (
        <ul>
          <li><b>{eintrag.anzahl_wettkaempfer || 0}</b> Wettkämpfer werden wieder eingeblendet.</li>
          <li>Meldungen und Ergebnisse sind unverändert da.</li>
          <li>Der Verein kann sich mit seinem bisherigen Passwort wieder anmelden.</li>
        </ul>
      ) : (
        <ul>
          <li><b>{eintrag.anzahl_wettkaempfer || 0}</b> Wettkämpfer kommen mit zurück.</li>
          <li>Aus dem alten Archiv: frühere Turnier-Meldungen kommen nicht zurück.</li>
          <li>Das alte Passwort gilt nicht mehr. Der Verein setzt über „Passwort vergessen“ ein neues.</li>
        </ul>
      )}
      <FehlerZeile text={fehler} />
    </Dialog>
  );
}

export function LoeschenDialog({ verein, wettkaempfer, meldungen, archiviert, onArchivieren, onOk, onSchliessen }) {
  const [text, setText] = useState('');
  const { belegt, fehler, los } = useAktion(onOk);
  const passt = text.trim() === String(verein.name).trim();
  return (
    <Dialog sym="muell" rot titel={`${verein.name} endgültig löschen?`} text="Das lässt sich nicht rückgängig machen." onSchliessen={onSchliessen} belegt={belegt}
      fuss={<>
        {!archiviert && onArchivieren && <button className="vv-k" onClick={onArchivieren} disabled={belegt}><Sym n="archiv" /> Lieber archivieren</button>}
        <button className="vv-k" onClick={onSchliessen} disabled={belegt}>Abbrechen</button>
        <button className="vv-k vv-k-haupt" onClick={() => los(text.trim())} disabled={!passt || belegt}><Sym n="muell" /> {belegt ? 'Löscht …' : 'Endgültig löschen'}</button>
      </>}>
      <p className="vv-dialog-notiz">Mit gelöscht werden:</p>
      <ul>
        <li><b>{wettkaempfer}</b> Wettkämpfer mit Fotos und Einwilligungen</li>
        <li><b>{meldungen}</b> Turnier-Meldungen{meldungen ? ' mit Ergebnissen (auch in Startlisten, Turnierbäumen, Ranglisten und Einwaage)' : ''}</li>
        <li>Archiv-Einträge und Zugangsdaten</li>
      </ul>
      {meldungen > 0 && <div className="vv-hinweis"><Sym n="achtung" /><div>Meldungen vorhanden. {archiviert ? 'Im Archiv bleiben sie erhalten; Löschen nimmt sie mit.' : <>Meist ist <b>Archivieren</b> der richtige Weg: es behält Meldungen und Ergebnisse.</>}</div></div>}
      <div className="vv-feld">
        <label htmlFor="vv-loeschtext">Zur Bestätigung den Namen eintippen: <b>{verein.name}</b></label>
        <input id="vv-loeschtext" autoComplete="off" value={text} onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && passt && !belegt) los(text.trim()); }} />
      </div>
      <FehlerZeile text={fehler} />
    </Dialog>
  );
}

/** Allgemeine Rückfrage (ersetzt window.confirm/prompt auf der Vereinsseite). */
export function BestaetigenDialog({ sym = 'achtung', rot = false, titel, text, punkte = [], grundLabel, grundPlatzhalter, knopf, onOk, onSchliessen }) {
  const [grund, setGrund] = useState('');
  const { belegt, fehler, los } = useAktion(onOk);
  return (
    <Dialog sym={sym} rot={rot} titel={titel} text={text} onSchliessen={onSchliessen} belegt={belegt}
      fuss={<>
        <button className="vv-k" onClick={onSchliessen} disabled={belegt}>Abbrechen</button>
        <button className="vv-k vv-k-haupt" onClick={() => los(grund.trim())} disabled={belegt}><Sym n={sym} /> {belegt ? 'Einen Moment …' : knopf}</button>
      </>}>
      {punkte.length > 0 && <ul>{punkte.map((p) => <li key={p}>{p}</li>)}</ul>}
      {grundLabel && (
        <div className="vv-feld">
          <label htmlFor="vv-grund">{grundLabel}</label>
          <input id="vv-grund" maxLength={500} placeholder={grundPlatzhalter} value={grund} onChange={(e) => setGrund(e.target.value)} />
        </div>
      )}
      <FehlerZeile text={fehler} />
    </Dialog>
  );
}
